import { defineStore } from 'pinia';
import axios from "axios";

export const sourceReferencesStore = defineStore('sourceReferencesStore',{
    actions: {
        getSourceReferencesList(params) {
            return axios.get(`/api/source/references`, {
                params: params
            });
        }
    }
});